module.exports = __webpack_public_path__ + "img/bannerIII.8026790c.png";